import gql from "graphql-tag";

export const QUERY = gql`
  query SimulationCaseById($id: ID!) {
    simulationCaseById(id: $id) {
      id
      title
      instantReferral {
        referralValue
        referralContent
      }
      diagnosis {
        possibleOutcome
        isCorrectOutcome
      }
      treatment {
        possibleOutcome
        isCorrectOutcome
      }
      referral {
        possibleOutcome
        isCorrectOutcome
      }
      patientInformation {
        content
        isMarkdown
      }
      assessments {
        testName
        testResult {
          content
          isMarkdown
        }
      }
      status
      module
      difficulty
      clinicalCategory
      nextCase {
        title
        id
      }
    }
  }
`;

export const MUTATION = gql`
  mutation UpdateSimulationCase($input: UpdateSimulationCaseInput!) {
    updateSimulationCase(input: $input) {
      simulationCase {
        title
        instantReferral {
          referralValue
          referralContent
        }
        diagnosis {
          possibleOutcome
          isCorrectOutcome
        }
        treatment {
          possibleOutcome
          isCorrectOutcome
        }
        referral {
          possibleOutcome
          isCorrectOutcome
        }
        patientInformation {
          content
          isMarkdown
        }
        assessments {
          testName
          testResult {
            content
            isMarkdown
          }
        }
        status
        module
        difficulty
        clinicalCategory
        nextCase {
          title
          id
        }
      }
    }
  }
`;

export const CREATE_CASE = gql`
  mutation CreateSimulationCase($input: CreateSimulationCaseInput!) {
    createSimulationCase(input: $input) {
      simulationCase {
        title
        instantReferral {
          referralValue
          referralContent
        }
        diagnosis {
          possibleOutcome
          isCorrectOutcome
        }
        treatment {
          possibleOutcome
          isCorrectOutcome
        }
        referral {
          possibleOutcome
          isCorrectOutcome
        }
        patientInformation {
          content
          isMarkdown
        }
        assessments {
          testName
          testResult {
            content
            isMarkdown
          }
        }
        status
        module
        difficulty
        clinicalCategory
      }
    }
  }
`;

export const SIMULATION_CASE_LIST_QUERY = gql`
  query SimulationCaseList {
    simulationCaseList {
      id
      title
      patientInformation {
        content
        isMarkdown
      }
      status
      module
      difficulty
      clinicalCategory
    }
  }
`;

export const GET_CASE_COMPLETION = gql`
  mutation SendSimulationCaseCompletionMessage(
    $input: SimulationCaseCompletionMessageInput!
  ) {
    sendSimulationCaseCompletionMessage(input: $input)
  }
`;
